import React from "react";
import {FourPointStar, CrookedStar} from "../../../assets";

const GuaranteeScoreProduct2 = () => {
  return (
    <section className="overflow-x-clip st-guarantee-section py-10 sm:py-12 lg:py-14" id="guarantee-score">
      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative st-guarantee-card px-6 py-12 text-center sm:px-10 sm:py-14 lg:px-14 lg:py-16">
          

          <div className="relative z-20 mx-auto flex max-w-5xl flex-col items-center">
            <div className="text-[72px] leading-none sm:text-[84px] lg:text-[92px]" aria-hidden="true">
              🏆
            </div>

            <div className="mt-5 text-[18px] st-guarantee-heading sm:text-[20px] lg:text-[22px]">
              Garansi Skor
            </div>

            <div className="mt-8 text-[82px] st-guarantee-score font-bold leading-none sm:text-[110px] lg:text-[140px]">
              6.5
            </div>

            <div className="mt-4 text-[22px] font-medium uppercase tracking-[0.16em] st-guarantee-cta sm:text-[24px] lg:text-[28px]">
              Target Minimum
            </div>

            <p className="st-font-body mt-8 max-w-5xl text-[24px] leading-[1.55] st-guarantee-cta sm:text-[24px] lg:text-[30px]">
              Kalau skor real test kamu tidak mencapai 6.5, kamu bisa mengikuti program intensif tambahan secara <strong className="font-extrabold st-guarantee-score">GRATIS</strong> selama 60 hari
            </p>

            <p className="st-font-body mt-8 text-[16px] leading-[1.55] st-guarantee-note sm:text-[18px] lg:text-[24px]">
              *Syarat &amp; ketentuan berlaku. Lihat detail di halaman pendaftaran.
            </p>
          </div>
        </div>
        <img
            src={FourPointStar}
            alt=""
            className="pointer-events-none absolute rotate-[35deg] left-[-38px] top-[64%] z-10 hidden w-[145px] md:block lg:left-[-3rem] lg:w-[14rem]"
            loading="lazy"
          />
          <img
            src={CrookedStar}
            alt=""
            className="pointer-events-none absolute rotate-[-35deg] right-[-64px] top-[4%] z-10 hidden w-[220px] md:block lg:right-[-20px] lg:w-[16rem]"
            loading="lazy"
          />
      </div>
    </section>
  );
};

export default GuaranteeScoreProduct2;